import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useApp } from '../contexts/AppContext';
import { wardNames } from '../data/checklists';
interface SwitchWardProps {
  onComplete: () => void;
}
export function SwitchWard({
  onComplete
}: SwitchWardProps) {
  const {
    colors
  } = useTheme();
  const {
    currentWard,
    setCurrentWard
  } = useApp();
  const wards = Object.entries(wardNames).map(([id, name]) => ({
    id,
    name
  }));
  const handleSelectWard = (wardId: string) => {
    setCurrentWard(wardId as any);
    onComplete();
  };
  return <div className="space-y-4" data-id="element-566">
      <h2 className="text-xl font-bold" data-id="element-567">Switch Ward</h2>
      <p className="opacity-70" data-id="element-568">Currently in: {wardNames[currentWard]}</p>
      <div className="space-y-3 mt-4" data-id="element-569">
        {wards.map(ward => <button key={ward.id} onClick={() => handleSelectWard(ward.id)} className="w-full p-4 rounded-lg text-left flex items-center justify-between" style={{
        backgroundColor: colors.cardSurface,
        borderLeft: ward.id === currentWard ? `4px solid ${colors.accent}` : 'none'
      }} data-id="element-570">
            <span className="font-medium" data-id="element-571">{ward.name}</span>
            {ward.id === currentWard && <span className="text-xs px-2 py-0.5 rounded" style={{
          backgroundColor: colors.accent + '20',
          color: colors.accent
        }} data-id="element-572">
                Current
              </span>}
          </button>)}
      </div>
    </div>;
}